import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgbDropdownModule, NgbModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ThemeModeService } from '../../../core/services/theme-mode.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppService } from '../../../app.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RightSidebarComponent } from '../right-sidebar/right-sidebar.component';
import { CommonModule } from '@angular/common';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertService } from '../../shared/alert/alert.service';
import "amazon-connect-streams";
import { CallService } from './CallService';
@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    NgbDropdownModule,
    RouterLink,
    MatIconModule,
    MatButtonModule,
    NgbModule,
    MatSidenavModule,
    RightSidebarComponent,
    CommonModule,
    MatOptionModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatTooltipModule
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit {
  @ViewChild("ccpDiv") public ccpDiv: ElementRef;
  @ViewChild('sidenav') sidenav: any;
  private readonly tokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  userName: any
  userEmail: any
  currentTheme: string;
  authData: any;
  sechudleType: any;
  linkCount: any;
  phoneLoginWin: any;
  currAgent: any;
  helpDial: any;
  ccpUrl: string | undefined;
  contactNumber = "";
  ccpInstance = "";
  instance: any;

  dynamicHeader: any = null;
  headerSubscription: Subscription | undefined;

  constructor(public router: Router,
    public themeModeService: ThemeModeService,
    public mainService: AppService,
    public modalService: NgbModal,
    public alertService: AlertService,
    public callService: CallService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) {
    this.mainService.loginData$.subscribe(res => {
      if (res) {
        setTimeout(() => {
          this.loginDetails = res;
          localStorage.setItem('userName', this.loginDetails.userName);
          localStorage.setItem('userEmail', this.loginDetails.userEmail);
          localStorage.setItem('userId', this.loginDetails.userID);
          this.getUserDetails();
        }, 0);
      }
    })
  }

  showDialerButton: boolean = false;
  selectedCountryCode: string = '+1'; // Default country code (USA)
  phoneNumber: any = '';  // User input for phone number
  dialedNumber: string | null = null;
  showTabDialer: boolean = true; // Initially show the tab-dialer
  loginDetails: any
  contactId: string = '';
  audioElement: HTMLAudioElement;
  showSecondaryView() {
    this.showTabDialer = false; // Hide tab-dialer and show secondary view
  }

  goBack() {
    this.showTabDialer = true; // Show tab-dialer and hide secondary view
  }

  countryCodes: any[] = [
    { code: '+1', name: 'USA' },
    { code: '+44', name: 'UK' },
    { code: '+91', name: 'India' },
    { code: '+61', name: 'Australia' },
    { code: '+33', name: 'France' }
  ];

  ngOnInit(): void {
    this.themeModeService.currentTheme.subscribe((theme) => {
      this.currentTheme = theme;
      this.showActiveTheme(this.currentTheme);
    });
    this.getUserDetails();
    this.isDialer();

    // Don't auto-open dialer on load – open only when user clicks dialer or on incoming call (avoids opening again on every tab/navigation)

    // Subscribe to incoming call state
    this.mainService.showIncomingTab$.subscribe(show => {
      if (show) {
        this.openTabDialer();
      }
    });

    this.mainService.incomingCallerInfo$.subscribe(info => {
      if (info) {
        this.callerInfo = info;
      }
    });

    this.headerSubscription = this.mainService.dynamicHeader$.subscribe(header => {
      this.dynamicHeader = header;
      this.cdr.detectChanges();
    });
  }

  callerInfo: any = null;

  openTabDialer() {
    this.showTabDialer = true;
    this.openSidebar(true); // Force open CCP on incoming call
  }

  isDialer() {
    let services = localStorage.getItem('services')
    let roles = localStorage.getItem('roles')
    // Show dialer if user has Call service, or is agent role (Client Agent, Supervisor, IT Admin)
    const hasCallService = services?.includes('Call')
    const isAgentRole = roles === 'Client Agent' || roles === 'Supervisor' || roles === 'IT Admin'
    if (hasCallService || isAgentRole) {
      this.showDialerButton = true
    }
    if (roles === 'Client' || roles === 'SuperAdmin' || roles === 'Account Manager' || roles === 'Dev') {
      this.showDialerButton = false
    }
  }
  userRole: any
  isLogin = true
  getUserDetails() {
    this.userName = localStorage.getItem('userName')
    this.userEmail = localStorage.getItem('userEmail')
    this.userRole = localStorage.getItem('roles')
    this.mainService.cadStatusData.next(this.isLogin)
  }

  open(content: any) {
    this.modalService.open(content, {
      windowClass: 'right-modal',
      size: 'lg',
      keyboard: true,
      backdrop: false,
    });
  }
  /** @param forceOpen - when true, always open (e.g. on incoming call). When false, toggle open/close */
  openSidebar(forceOpen = false) {
    if (forceOpen) {
      this.mainService.rightNavToggle.next(true);
    } else {
      this.mainService.ccpOpened$.pipe(take(1)).subscribe(isOpen => {
        this.mainService.rightNavToggle.next(!isOpen);
      });
    }
  }
  showActiveTheme(theme: string) {
    const themeSwitcher = document.querySelector('#theme-switcher') as HTMLInputElement;
    const box = document.querySelector('.box') as HTMLElement;

    if (!themeSwitcher) {
      return;
    }

    // Toggle the custom checkbox based on the theme
    if (theme === 'dark') {
      themeSwitcher.checked = true;
      box.classList.remove('light');
      box.classList.add('dark');
    } else if (theme === 'light') {
      themeSwitcher.checked = false;
      box.classList.remove('dark');
      box.classList.add('light');
    }
  }

  /**
   * Change the theme on #theme-switcher checkbox changes 
   */
  onThemeCheckboxChange(e: Event) {
    const checkbox = e.target as HTMLInputElement;
    const newTheme: string = checkbox.checked ? 'dark' : 'light';
    this.themeModeService.toggleTheme(newTheme);
    this.showActiveTheme(newTheme);
  }

  /**
   * Toggle the sidebar when the hamburger button is clicked
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    document.body.classList.add('sidebar-open');
    document.querySelector('.sidebar .sidebar-toggler')?.classList.add('active');
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    e.preventDefault();
    localStorage.setItem('isLoggedin', 'false');
    (window as any).__ccpInitialized = false;
    try { localStorage.removeItem('ccpConnected'); } catch (_) { }
    if (localStorage.getItem('isLoggedin') === 'false') {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userID');
      localStorage.removeItem('userName');
      localStorage.removeItem('access_token');
      localStorage.removeItem('userDetails');
      localStorage.removeItem('appUserID');
      localStorage.removeItem('customerID');
      localStorage.removeItem('caseID');
      this.tokenSubject.next(null);
      this.alertService.warning('User logged out')
    }
    window.location.reload();
  }



  logout: boolean = false;
  callCare: boolean = false;
  isToggled: boolean = true;
  subscription: Subscription | undefined;
  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
    this.headerSubscription && this.headerSubscription.unsubscribe();
  }

  onHeaderAction(action: any) {
    if (action && action.callback) {
      action.callback();
    }
  }

  payload: boolean = false
  openSideNav(name: any) {

    //this.mainService.sideNavToggle.next(obj)
  }
  // Add a digit to the phone number
  appendToPhoneNumber(digit: string) {
    this.phoneNumber += digit;
  }



  ccpInit() {
    if ((window as any).__ccpInitialized) return; // CCP already in custom-dialer – avoid re-init and postMessage errors
    if (!this.ccpDiv?.nativeElement) return;
    this.ccpUrl = "https://tscti-demo.my.connect.aws/ccp-v2/softphone";
    const ccpUrl = "https://tscti-demo.my.connect.aws/ccp-v2/softphone";
    connect.core.initCCP(this.ccpDiv.nativeElement, {
      ccpUrl,
      loginPopup: true,
      loginPopupAutoClose: false,
      loginOptions: {
        autoClose: true,
        height: 600,
        width: 400,
        top: 0,
        left: 0,

      },
      softphone: {
        allowFramedSoftphone: true
      },
      pageOptions: {
        enableAudioDeviceSettings: false,
        enablePhoneTypeSettings: false,
      }
    });

    const headerButton: any = document.querySelector('.ccp-header button');
    if (headerButton) {
      headerButton.disabled = true; // This will disable the button
    }

    let comp = this;
    connect.contact((contact: { onConnected: (arg0: (contact2: any) => void) => void; }) => {
      console.log("contact", contact);
      contact.onConnected((contact2: any) => {
        console.log("connected", contact2);

        comp.contactNumber = contact2.getActiveInitialConnection()
          .getEndpoint().phoneNumber;
        console.log("verify", comp.contactNumber);


        console.log(
          "accept",
          contact2.onAccepted((end: any) => {
            console.log("accepted", end);
          })
        );
        if (
          contact2.getActiveInitialConnection()?.getEndpoint()
        ) {
          connect.agent((agent: { getName: () => any; }) => {
            console.log("agent", agent.getName());
          });

          contact2.onEnded((end: any) => {
            comp.onended(end);
          })
          console.log(
            "end",
            contact2.onEnded((end: any) => {
              console.log("end", end);
            })
          );

        } else {
          console.log("This is an existing contact for this agent");
        }
      }); ``

    });
    connect.core.onInitialized(comp.onInitialized);
    connect.core.onAuthFail(comp.onAuthFail);
    connect.core.onAccessDenied(comp.onAccessDenied);
    connect.core.getFrameMediaDevices(2000)
      .then((devices: any) => { console.log('Devices:', devices); })
      .catch((err: any) => {
        console.log(err);
      });
  }
  onInitialized() {
    console.log('onInitialized', arguments);
    this.phoneLoginWin && this.phoneLoginWin.close();
  }

  onWebSocketInitFailure() { console.log('onWebSocketInitFailure'); }
  phoneLogin() {
    if (!this.ccpDiv.nativeElement.children.length) {
      this.terminate();
      this.ccpInit();
    }
    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=500,height=700,right=0,top=100`;
    this.phoneLoginWin = window.open(this.ccpUrl, 'ccp', params);
    setTimeout(() => { this.phoneLoginWin && this.phoneLoginWin.close(); }, 12000);
  }
  onAuthFail() {
    console.log('onAuthFail');
  }
  onAccessDenied() {
    console.log('onAccessDenied');
  }
  terminate() {
    connect.core.terminate();
    (window as any).__ccpInitialized = false;
    try { localStorage.removeItem('ccpConnected'); } catch (_) { }
    let iframe = this.ccpDiv.nativeElement.firstElementChild; // assumes there's nothing else in the container
    iframe && this.ccpDiv.nativeElement.removeChild(iframe);
  }
  connectAgent(agent: any) {

  }
  callNo(no: any) {
    let endpoint = connect.Endpoint.byPhoneNumber(no); //"+18005550100"
    let agent = new connect.Agent();
    let queueArn = `arn:aws:connect:us-east-1:$ACCOUNT_ID:instance/'+this.ccpInstance+'/queue/$CONNECT_QUEUE_ID`;
    agent.connect(endpoint, {
      queueARN: queueArn,
      success: function () { console.log("outbound call connected"); },
      failure: function (err: any) {
        console.log("outbound call connection failed");
        console.log(err);
      }
    });
  }


  onended(enData: any) {


  }
  setVolume(value: number): void {
    // Set the volume (0 to 1) for the audio element
    this.audioElement.volume = value;
  }
  backspace() {
    this.phoneNumber = this.phoneNumber.slice(0, -1);
  }

  clearPhoneNumber() {
    this.phoneNumber = '';
  }

}
